import i18n, { LANGUAGES } from '../i18n';

/**
 * Normalize a free-text name to an ID-like value
 */
export const convertNameToId = (name: string): string => {
  return name.trim().toLowerCase().replace(/\s+/g, '-');
};

/**
 * Normalize any translation of "common" to the canonical 'common' ID.
 * Uses available languages from i18n to compare translations.
 */
export const normalizeResponsible = (responsible: string): string => {
  const lowerResponsible = responsible.toLowerCase();
  const languages = Object.keys(LANGUAGES);
  const fromI18n = languages.map((lang) =>
    i18n.getFixedT(lang)('defaults.responsibles.common').toLowerCase()
  );
  // Fallback list for when i18n resources are not yet loaded
  const fallbacks = ['common', 'commun', 'gemeenschappelijk'];
  const commonTranslations = Array.from(new Set([...fromI18n, ...fallbacks]));
  if (commonTranslations.includes(lowerResponsible)) return 'common';
  return responsible;
};

/** Normalize any translation of "cash" to canonical 'cash' destination id */
export const normalizeDestination = (destination: string): string => {
  const lowerDestination = destination.toLowerCase();
  const languages = Object.keys(LANGUAGES);
  const fromI18n = languages.map((lang) =>
    i18n.getFixedT(lang)('defaults.destinations.cash').toLowerCase()
  );
  const fallbacks = ['cash', 'espèces', 'contant'];
  const cashTranslations = Array.from(new Set([...fromI18n, ...fallbacks]));
  if (cashTranslations.includes(lowerDestination)) return 'cash';
  return destination;
};
